var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.999 511.999",
    style: {
      enableBackground: "new 0 0 511.999 511.999"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9811"
    },
    points: "0.001,44.522 0,44.522 0,467.477 0.001,467.477 0.001,256.001 "
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFDA44"
    },
    cx: 255.999,
    cy: 255.999,
    r: 255.999
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9811"
    },
    d: "M200.349,44.522h-88.635c-3.928,2.685-7.772,5.48-11.539,8.373L77.914,255.999l22.261,203.104 c3.767,2.894,7.611,5.689,11.539,8.373h88.635V44.522z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6DA544"
    },
    d: "M0.001,256.001c0,82.745,39.268,156.307,100.174,203.104V52.896 C39.269,99.694,0.001,173.256,0.001,256.001z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "411.826,156.064 411.826,162.469 412.064,162.505 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A2001D"
    },
    d: "M491.595,322.782h-48.233l-20.405,22.261v44.522h-44.522v-22.261h22.261v-44.522H300.522v27.826 h-22.261v-53.031c-6.83-6.114-11.13-14.995-11.13-24.882V128c0-18.441,14.95-33.391,33.391-33.391v205.913h44.522l15.276-12.731 c-2.668-6.355-4.146-13.334-4.146-20.66v-33.391h-33.391v-66.782h66.782c0-11.13,16.696-22.261,16.696-22.261 s16.696,11.13,16.696,22.261v16.696v50.087c12.383,0.147,32.057-0.174,53.312,0c-5.584-9.76-8.791-21.341-8.791-33.391 c0-19.641,8.48-37.299,21.978-49.519C470,107.716,438.954,70.954,400.287,44.522H233.74v422.956h166.548 c47.019-32.141,82.768-79.552,100.112-135.09L491.595,322.782z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLk);
export default __webpack_public_path__ + "static/media/lk.d19c0fb37f0f43518f92b656b9aa638f.svg";
export { ForwardRef as ReactComponent };